<div class="tab-content match-summary live-timeline basketball-timeline-container">
    @for (val of actions; track $index) {
        <div
            class="tab-pane show active"
            id="tab-match-summary-1-content"
            role="tabpanel"
            aria-labelledby="tab-match-summary-1"
        >
            @if (!isUnknown) {
                <h6
                    class="text-center text-uppercase match-summary__head dropdown-toggle"
                    data-toggle="collapse"
                    [attr.href]="'#collapseAction' + val[0]"
                    role="button"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapseAction' + val[0]"
                >
                    {{ 'web.' + sportName + '_' + val[0] | lowercase | translate }}
                </h6>
            }
            <div class="collapse show" [attr.id]="'collapseAction' + val[0]">
                @for (action of val[1]; track $index; let isLastMain = $last; let rowIndex = $index) {
                    <div class="">
                        <div
                            data-toggle="collapse"
                            [attr.href]="'#collapseTimelineEvent' + action.id"
                            role="button"
                            aria-expanded="false"
                            [attr.aria-controls]="'collapseTimelineEvent' + action.id"
                            class="basketball-timeline d-flex align-items-center no-gutters border-top py-1 px-1 small ng-star-inserted collapsed"
                        >
                            <div class="px-2 chevron-container">
                                @if (isActionCollapsible(action)) {
                                    <i class="fa timeline-chevron"></i>
                                }
                            </div>
                            @if (action.match_clock || action.match_time) {
                                <div class="px-1">
                                    <span>{{ action.match_clock || action.match_time }}</span>
                                </div>
                            }
                            @if (action.competitor && !hasIcon(action)) {
                                <div class="px-1">
                                    @if (participant(action.competitor)?.image !== null) {
                                        <img
                                            [src]="participant(action.competitor)?.image"
                                            [alt]="participant(action.competitor)?.name"
                                            height="40"
                                            width="40"
                                            style="object-fit: contain"
                                            class="mr-1"
                                        />
                                    }
                                    @if (participant(action.competitor)?.image === null) {
                                        <img
                                            [src]="'/img/default-logo.svg'"
                                            [alt]="participant(action.competitor)?.name"
                                            height="40"
                                            width="40"
                                            style="object-fit: contain; visibility: hidden"
                                            class="mr-1"
                                        />
                                    }
                                </div>
                            }
                            @if (hasIcon(action)) {
                                <div class="px-1 action-icon text-muted">
                                    <i class="{{ getIcon(action) }}"></i>
                                </div>
                            }
                            <div class="flex-grow-1 pr-2">
                                <div class="font-0-8x font-weight-bold">
                                    {{ 'web.timeline_basketball_type_' + action.type + '_short' | translate }}
                                </div>
                                <div class="text-muted small">
                                    {{ action.description }}
                                </div>
                            </div>
                            @if (
                                (rowIndex > 0 && action.home_score !== val[1][rowIndex - 1].home_score) ||
                                (rowIndex > 0 && action.away_score !== val[1][rowIndex - 1].away_score)
                            ) {
                                <div class="pr-1 text-center">
                                    <div class="text-muted small">
                                        {{ participant('home')?.alias }}
                                    </div>
                                    <div
                                        class="font-weight-bold font-1x"
                                        [ngClass]="{
                                            'emph-text-node':
                                                rowIndex > 0 && action.home_score !== val[1][rowIndex - 1].home_score,
                                        }"
                                    >
                                        {{ action.home_score }}
                                    </div>
                                </div>
                                <div class="pr-1 text-center">
                                    <div class="text-muted small">&nbsp;</div>
                                    <div class="font-weight-bold font-1x">:</div>
                                </div>
                                <div class="pr-1 text-center">
                                    <div class="text-muted small">
                                        {{ participant('away')?.alias }}
                                    </div>
                                    <div
                                        class="font-weight-bold font-1x"
                                        [ngClass]="{
                                            'emph-text-node':
                                                rowIndex > 0 && action.away_score !== val[1][rowIndex - 1].away_score,
                                        }"
                                    >
                                        {{ action.away_score }}
                                    </div>
                                </div>
                            }
                        </div>
                        @if (isActionCollapsible(action)) {
                            <div
                                class="collapse action-additional-info py-2"
                                [attr.id]="'collapseTimelineEvent' + action.id"
                            >
                                @for (player of action.players; track $index) {
                                    <div class="d-flex">
                                        <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                            <img
                                                (error)="imageError($event, 'avatar')"
                                                [attr.alt]="player?.name"
                                                [src]="'/assets/players/photos/' + player?.id + '.png'"
                                                height="40"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div class="pb-2">
                                            <div class="font-0-8x">
                                                <span class="font-weight-bold">
                                                    <a
                                                        [routerLink]="[
                                                            '/page/sport/player',
                                                            sportName + '-' + sportId,
                                                            player.id,
                                                        ]"
                                                        class="text-reset"
                                                        >{{ player.name }}</a
                                                    >
                                                </span>
                                                {{ player?.participant ? '(' + player.participant.alias + ')' : '' }}
                                            </div>
                                            <div class="text-muted small">
                                                {{
                                                    'web.' + this.sportName + '_timeline-player-type_' + player.type
                                                        | translate
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
